import EditSchedule from '../../containers/editSchedule/index'
import AppShell from '../../components/layout/AppShell'

export default function EditSchedulePage() {
    return (
        <AppShell title="Редактирование расписания">
            <EditSchedule />
        </AppShell>
    )
}
